<div class="container pt-5 px-lg-0">
	<div class="my-5">
		<div class="text-center mb-2 d-flex justify-content-end">
			<h1 class="titolo-bertazzoni w-100">CONFIGURAZIONE CONTAINERIZZATORE</h1>
			<button type="button" class="btn btn-bertazzoni black rounded-0 px-4" (click)="aggiungiConfigurazione()">AGGIUNGI</button>
		</div>
		<div class="row">
			<div class="col-12">
				<!--LASCIARE ORDINAMENTO SOLO SU COLONNA CLIENTE AS400, LE SELECT DELLE ALTRE DUE COLONNE PARTONO DISABILITATE E IL BTN SALVA NASCOSTO. SI ATTIVA TUTTO AL CLICK SULLA MODIFICA-->
				<table #datatable datatable [dtOptions]="dtSettings" [dtTrigger]="dtTrigger" class="row-border hover">
					<thead>
						<tr>
							<th>Codice collo</th>
							<th>3o carattere</th>
							<th>8o carattere</th>
							<th>Sovrapponibilitá</th>
							<th></th>
						</tr>
					</thead>
					<tbody *ngIf="listaConfigurazioneProdottoContainer?.length > 0">
						<tr *ngFor="let configurazione of listaConfigurazioneProdottoContainer">
							<td>
								<input
									maxlength="2"
									minlength="2"
									class="font-weight-bold font-12 mr-2"
									name="configurazione_codice_{{configurazione.id}}"
									[disabled]="!configurazione.feEdit"
									[(ngModel)]="configurazione.codice" />
								<span class="d-none">{{configurazione.codice}}</span>
							</td>
							<td>
								<input
									maxlength="1"
									minlength="1"
									class="font-weight-bold font-12 mr-2"
									name="configurazione_codice_3_{{configurazione.id}}"
									[disabled]="!configurazione.feEdit"
									[(ngModel)]="configurazione.terzoCarattere" />
							</td>
							<td>
								<input
									maxlength="1"
									minlength="1"
									class="font-weight-bold font-12 mr-2"
									name="configurazione_codice_8_{{configurazione.id}}"
									[disabled]="!configurazione.feEdit"
									[(ngModel)]="configurazione.ottavoCarattere" />
							</td>
							<td>
								<input
									type="number"
									class="font-weight-bold font-12 mr-2"
									name="configurazione_sovrapponibilita_{{configurazione.id}}"
									[disabled]="!configurazione.feEdit"
									[(ngModel)]="configurazione.sovrapponibilita" />
							</td>
							<td>
								<button
									type="button"
									class="btn btn-bertazzoni black rounded-0"
									*ngIf="configurazione.feEdit"
									(click)="salvaConfigurazione(configurazione)"
									[disabled]="configurazione.codice && configurazione.codice.length !== 2 && configurazione.sovrapponibilita < 1">
									{{ configurazione.id ? 'SALVA' : 'AGGIUNGI' }}
								</button>
								<img
									src="assets/img/pencil.svg"
									class="action-icon mr-3"
									*ngIf="!configurazione.feEdit"
									(click)="configurazione.feEdit = !configurazione.feEdit" />
								<img
									src="assets/img/delete.svg"
									class="action-icon"
									*ngIf="!configurazione.feEdit"
									(click)="deleteConfigurazione(configurazione)" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="text-center mb-2 d-flex justify-content-end mt-5">
			<h1 class="titolo-bertazzoni w-100">CONFIGURAZIONE GRUPPI</h1>
			<button type="button" class="btn btn-bertazzoni black rounded-0 px-4" (click)="aggiungiGruppo()">AGGIUNGI</button>
		</div>

		<div class="row ">
			<div class="col-12">
				<div *ngFor="let gruppo of listaGruppiConfigurazioneProdottoContainer">
					<hr class="my-4" />

					<div class="d-flex w-100 justify-content-center align-items-center">
						<h4 *ngIf="gruppo.id">Gruppo {{gruppo.id}}</h4>
						<h4 *ngIf="!gruppo.id">Nuovo gruppo</h4>
						<button
							type="button"
							class="btn btn-bertazzoni black rounded-0 px-4 ml-4"
							[disabled]="!gruppo.sovrapponibilita"
							(click)="salvaGruppo(gruppo)">
							SALVA GRUPPO
						</button>
						<button type="button" class="btn btn-bertazzoni black rounded-0 px-4 ml-4" (click)="aggiungiConfigurazioneAlGruppo(gruppo)">
							AGGIUNGI CONFIGURAZIONE
						</button>
					</div>

					<div class="d-flex w-100 justify-content-center align-items-center my-3">
						<h6>Sovrapponibilit&agrave;</h6>
						<input
							type="number"
							class="font-weight-bold font-12 ml-4"
							name="gruppo_sovrapponibilita_{{gruppo.id}}"
							[(ngModel)]="gruppo.sovrapponibilita" />
					</div>

					<p *ngIf="!gruppo.configurazioni.length" class="w-100 text-center">Nessuna configurazione</p>
					<table class="row-border hover mx-auto" *ngIf="gruppo.configurazioni.length">
						<thead>
							<tr>
								<th>Codice collo</th>
								<th>3o carattere</th>
								<th>8o carattere</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let configurazione of gruppo.configurazioni">
								<td>
									<input
										maxlength="2"
										minlength="2"
										class="font-weight-bold font-12 mr-2"
										name="configurazione_codice_{{configurazione.id}}"
										[(ngModel)]="configurazione.codice" />
								</td>
								<td>
									<input
										maxlength="1"
										minlength="1"
										class="font-weight-bold font-12 mr-2"
										name="configurazione_codice_3_{{configurazione.id}}"
										[(ngModel)]="configurazione.terzoCarattere" />
								</td>
								<td>
									<input
										maxlength="1"
										minlength="1"
										class="font-weight-bold font-12 mr-2"
										name="configurazione_codice_8_{{configurazione.id}}"
										[(ngModel)]="configurazione.ottavoCarattere" />
								</td>
								<td>
									<button type="button" class="btn btn-bertazzoni black rounded-0 px-4 " (click)="rimuoviDalGruppo(configurazione, gruppo)">
										RIMUOVI
									</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #scegliProdottoModal let-modal>
	<div class="modal-header">
		<h6 class="modal-title" id="">Salvataggio completato</h6>
		<button type="button" class="close" aria-label="Close" (click)="modal.close()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
</ng-template>
